import { render, staticRenderFns } from "./RefineFilterModal.vue?vue&type=template&id=20b4dcc6&scoped=true"
import script from "./RefineFilterModal.vue?vue&type=script&lang=ts"
export * from "./RefineFilterModal.vue?vue&type=script&lang=ts"
import style0 from "./RefineFilterModal.vue?vue&type=style&index=0&id=20b4dcc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4dcc6",
  null
  
)

export default component.exports